
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class SocialService extends ApiEvsService {
    constructor(http: Http, router: Router) {
        super(http, router);
    }

  listPage(tenantId?: any) {
    return this.getServer('/omap/pages?tenant_id='+tenantId);
  }

  addPage(body: any) {
    return this.postServer('/omap/pages',body);
  }

  updatePage(body: any, page_id) {
    return this.putServer('/omap/pages' + page_id ,body);
  }

  findPage(page_id) {
    return this.getServer('/omap/pages/'+ page_id);
  }

  deletePage(page_id) {
    return this.deleteServer('/omap/pages/'+ page_id);
  }
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/common/services/Social.service.ts